export default {"src":"/_next/static/media/qr-code-google-play.dcc3c241.svg","height":980,"width":980,"blurWidth":0,"blurHeight":0};